module.exports = __webpack_public_path__ + "static/media/penpaper.bbac84bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/penpaper.png
// module id = 1361
// module chunks = 0